interface AvatarProps {
  initials: string;
  size?: number;
}

export function Avatar({ initials, size = 36 }: AvatarProps): JSX.Element {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: size,
        background: 'var(--rx-brand-tint)',
        color: 'var(--rx-brand)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Geist, ui-sans-serif, sans-serif',
        fontWeight: 600,
        fontSize: size * 0.36,
        letterSpacing: '-0.2px',
        flexShrink: 0,
      }}
    >
      {initials}
    </div>
  );
}

export function initialsFrom(value: string | undefined | null, max = 2): string {
  if (!value) return '—';
  const parts = value.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '—';
  return parts
    .slice(0, max)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('');
}
